import React from 'react';
import { RouteIcon, UserIcon, ListIcon, CarIcon } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { NODE_TYPE_DISPLAY } from './ReconciliationTable.constants';

interface NodeIconProps {
  nodeType: string;
}

/**
 * Component to display appropriate icon based on node type
 * Supports BRAND, DRIVER, ROUTE, CUSTOMER
 */
export const NodeIcon: React.FC<NodeIconProps> = ({ nodeType }) => {
  switch (nodeType) {
    case 'BRAND':
      return (
        <Tooltip>
          <TooltipTrigger>
            <ListIcon className="h-4 w-4 text-gray-500" />
          </TooltipTrigger>
          <TooltipContent>{NODE_TYPE_DISPLAY.BRAND}</TooltipContent>
        </Tooltip>
      );
    case 'DRIVER':
      return (
        <Tooltip>
          <TooltipTrigger>
            <CarIcon className="h-4 w-4 text-gray-500" />
          </TooltipTrigger>
          <TooltipContent>{NODE_TYPE_DISPLAY.DRIVER}</TooltipContent>
        </Tooltip>
      );
    case 'ROUTE':
      return (
        <Tooltip>
          <TooltipTrigger>
            <RouteIcon className="h-4 w-4 text-gray-500" />
          </TooltipTrigger>
          <TooltipContent>{NODE_TYPE_DISPLAY.ROUTE}</TooltipContent>
        </Tooltip>
      );
    case 'CUSTOMER':
      return (
        <Tooltip>
          <TooltipTrigger>
            <UserIcon className="h-4 w-4 text-gray-500" />
          </TooltipTrigger>
          <TooltipContent>{NODE_TYPE_DISPLAY.CUSTOMER}</TooltipContent>
        </Tooltip>
      );
    default:
      return null;
  }
};
